import React from 'react';
import { useNavigate } from 'react-router-dom';
import ActivityForm from '../components/Forms/ActivityForm';
import { useAuth } from '../hooks/useAuth';

const AddActivityPage = ({ onClose } = {}) => {
  const navigate = useNavigate();
  const { user } = useAuth();

  if (!user) {
    return (
      <div className="add-activity-page">
        <h1>Aktivität erstellen</h1>
        <p>Bitte melden Sie sich an, um eine Aktivität zu erstellen.</p>
      </div>
    );
  }

  const handleSuccess = (activityId) => {
    if (onClose) onClose();
    if (activityId) {
      navigate(`/aktivitaet-kontrolle/${activityId}`);
    } else {
      navigate('/meine-aktivitaeten');
    }
  };

  return (
    <div>
      <ActivityForm onSuccess={handleSuccess} />
    </div>
  );
};

export default AddActivityPage;
